'use client';

import { session as sessionStore } from '@ahm/common-helpers';
import { Button, Group, Modal, Text, rem } from '@mantine/core';
import { createTranslations, type Locales } from '../locales';
import { actionsLocales } from '../locales/actions';

export type ExpiredTokenModalProps = {
  opened: boolean;
  title: string;
  content: string;
  openAuthModal: boolean;
  isLogout?: boolean;
  lang?: keyof Locales;
  onClose: () => void;
};

export default function ExpiredTokenModal(innerProps: ExpiredTokenModalProps) {
  const { lang = 'vi' } = innerProps;
  const tActions = createTranslations({ locales: actionsLocales, lang });

  const handleCloseModal = () => {
    sessionStore.removeItem('authenError');
    innerProps.onClose();
  };

  return (
    <Modal
      opened={innerProps.opened}
      size={rem(450)}
      px={rem(24)}
      title={innerProps.title}
      radius={rem(12)}
      withCloseButton={false}
      centered
      closeOnClickOutside={false}
      closeOnEscape={false}
      onClose={() => {
        innerProps.onClose();
      }}
      styles={{
        body: {
          padding: '0px 16px 16px 16px',
          width: '100%',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
        },
        overlay: {
          zIndex: 1500,
        },
        inner: {
          zIndex: 1500,
        },
      }}
    >
      <Text size="sm" c="neutral.6" fw={500} pt={0}>
        {innerProps.content}
      </Text>
      <Group justify="flex-end" mt={rem(32)} gap={8}>
        <Button onClick={handleCloseModal} size="sm" h={rem(48)} miw={rem(120)}>
          {tActions('confirm')}
        </Button>
      </Group>
    </Modal>
  );
}
